const doPopup = (event) => {
    const e = event || window.event;
    const t = e.currentTarget ? e.currentTarget : e.srcElement;
    const width = 800;
    const height = 500;

    // popup position
    const px = Math.floor(((window.screen.availWidth || 1024) - width) / 2);
    const py = Math.floor(((window.screen.availHeight || 700) - height) / 2);

    // open popup
    const popup = window.open(
        t.href,
        'social',
        `width=${width},height=${height},left=${px},top=${py},location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1`,
    );

    if (popup) {
        popup.focus();
        if (e.preventDefault) {
            e.preventDefault();
        }
        e.returnValue = false;
    }

    return !!popup;
};

const handleShareLinks = () => {
    const shareLinks = document.querySelectorAll('.js-share');
    if (shareLinks.length > 0) {
        shareLinks.forEach((link) => {
            link.addEventListener('click', (event) => {
                doPopup(event);
            });
        });
    }
};

export default handleShareLinks;
